/* eslint-disable @typescript-eslint/no-empty-function */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import loadingGif from '../../assets/images/Innobo-Hub-loading.gif';
import usePageTitle from '../../common/hooks/usePageTitle';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getDynamicAttrUpdated, getDynamicFilterCF, transformCFColumnsData } from '../../helpers/tools_helper';
import { getMilestoneConfigSO, getSalesOrdersList } from '../../store/salesOrders/actions';
import { cancelFetchSO } from '../../store/salesOrders/saga';
import { getNameClient } from './../../helpers/nameClient';
import IForm from '../salesOrderList/iForm';
import * as url from '../../helpers/url_helper';
import { getTokenIframe } from '../../store/dashboardHl/actions';

const DashboardHollistics = (props: any) => {
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [title, setTitle] = useState('');

    const [urlState, setURLState] = useState(String);

    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });

    const PageTitleSO = usePageTitle(props.location.pathname);

    const groupName = 'salesOrdersDataViewList';

    const { salesOrdersData, isLoading, milestoneConfig, CountItems, token } = useSelector((state: any) => ({
        salesOrdersData: state.salesOrders.salesOrdersData,
        isLoading: state.salesOrders.isLoading,
        milestoneConfig: state.salesOrders.milestoneConfig,
        CountItems: state.salesOrders.CountItems,
        token: state.DashboardHL.token,
    }));

    const currentDate = new Date();

    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
        dynamicFilterCF: '',
    });

    const [salesOrderList, setSalesOrderList] = useState<any[]>([]);
    const [tableConfig, setTableConfig] = useState([]);

    const dispatch = useDispatch();

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }
        return t;
    };

    useEffect(() => {
        console.log(' Token  changed..  ', token);
        if (token) {
            const url = "https://us.holistics.io/embed/";
            const identificator = "97ef053616bf52488e1973cd";

            setURLState('https://us.holistics.io/embed/97ef053616bf52488e1973cd?_token=' + token);
            console.log(urlState);
        }
    }, [token]);

    useEffect(() => {
        dispatch(getMilestoneConfigSO());
    }, []);

    useEffect(() => {
        // showProgress();
        dispatch(getSalesOrdersList({ form, pagination }));
    }, [dispatch, form, pagination]);

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(salesOrdersData);
        setSalesOrderList(listFinal);
    }, [salesOrdersData]);

    useEffect(() => {
        const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
            const x = a.order;
            const y = b.order;
            if (x > y) {
                return 1;
            }
            if (x < y) {
                return -1;
            }
            return 0;
        });
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
        });
        setTableConfig(dataSorted);
    }, [milestoneConfig]);

    useEffect(() => {}, [salesOrdersData]);

    const hideProgress = () => {
        Swal.close();
    };
    const showProgress = () => {
        const brandLocalS = JSON.parse(localStorage.getItem('brand') || '');
        return Swal.fire({
            title: 'Loading data',
            backdrop: true,
            width: 500,
            allowEscapeKey: false,
            showCancelButton: true, //milestoneConfig.length === 0 ? false : true,
            allowOutsideClick: false,
            timerProgressBar: true,
            allowEnterKey: false,
            html: `<div style="display: flex; justify-content: center; align-items: center;">
              <img src="${brandLocalS.urlLoading ?? loadingGif}" alt="Loading..." style="width:100px; margin: 20px;" />
              </div>`,
            didOpen: () => {
                const confirmButton = Swal.getConfirmButton();
                if (confirmButton) {
                    confirmButton.style.display = 'none'; // Oculta el botón "Ok"
                }
                const cancelButton = Swal.getCancelButton();
                if (cancelButton) {
                    Object.assign(cancelButton.style, styles.cancelButton); // Aplica los estilos en línea al botón de cancelar
                }
            },
            customClass: {
                popup: 'my-swal-popup',
                cancelButton: 'my-swal-cancelButton',
            },
        }).then((result) => {
            console.log('primera entrada');
            if (result.dismiss === Swal.DismissReason.timer) {
                console.log('I was closed by the timer');
            }
            if (result.dismiss === Swal.DismissReason.cancel) {
                cancelFetchSO();
            }
        });
    };

    const styles = {
        cancelButton: {
            color: 'white',
            padding: '5px 50px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            width: '120px',
            height: '35px',
            paddingLeft: '35px',
            marginTop: '-20px',
        },
    };

    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const getFilterCF = getDynamicFilterCF(data);
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        const newForm = {
            ...data,
            order: form.order,
            dynamicFilter: filterString,
            dynamicFilterCF: getFilterCF,
        };
        setForm(newForm);
    };
    const handleActionOnRowClick = (row: any) => {
        const visibleInModalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => {
            return x.value;
        });
        setTitle(titleArr.join(' - '));
        setSelectedRow(row);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({ ...form, order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    //------------------------------------------hl------------------------------------------

    useEffect(() => {
        dispatch(getTokenIframe());
    }, []);
    return (
        <React.Fragment>
            {{ urlState } && (
                <iframe
                    data-v-9b74a260=""
                    src={`${urlState}`}
                    className="embedded-dashboard-iframe h-[800px] w-full"
                    frameBorder="0"
                    allowFullScreen={true}
                    width="100%"
                    height="900px"
                ></iframe>
            )}
            {/* <div className="page-content">
                <PageTitle>
                    <title>{PageTitleSO.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <Breadcrumbs title="Sales Order" breadcrumbItem={PageTitleSO.replace(/-/g, ' ')} />
                    <Row>
                        <Filters onSearchClicked={handleActionOnSearch} filterItems={milestoneConfig} groupName={groupName} />
                    </Row>
                    <Row>
                        <div className="container-sm">
                            <>{isLoading ? null : hideProgress()}</>
                        </div>
                        {salesOrderList.length > 0 ? (
                            milestoneConfig.length === 0 ? (
                                <>
                                    <div>No config operations for this table</div>
                                </>
                            ) : (
                                <>
                                    <ITable
                                        remote={true}
                                        CountItems={CountItems}
                                        handlerPaginationState={handlePaginationChange}
                                        data={salesOrderList}
                                        fields={milestoneConfig}
                                        tableColumns={milestoneConfig}
                                        headerColorT={'bg-primary text-white'}
                                        groupName={groupName}
                                        handlePopUpState={onPopUpState}
                                        actionOnRowClick={handleActionOnRowClick}
                                        handleTableSort={handleTableSort}
                                    />
                                </>
                            )
                        ) : <div style={{height:180}}/>}
                    </Row>
                </Container>
            </div>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Sales Orders'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
                width = '93%'
                height = '93%'
            >
                <IForm selectedRow={selectedRow} milestoneConfig={tableConfig} groupName={groupName} columsPop={5} />
            </IPopUp> */}
        </React.Fragment>
    );
};

export default DashboardHollistics;
